interface AccrualCycle {
  startDate: string;
  endDate: string;
  maturityDate: string;
  interestAmount: {
    amount: number;
    currency: string;
  };
  interestRate: string;
  balance: {
    amount: number;
    currency: string;
  };
  status: string;
}

export function getLatestCycle(accrualCycles: AccrualCycle[]): AccrualCycle | null {
  try {
    if (!Array.isArray(accrualCycles) || accrualCycles.length === 0) {
      return null;
    }

    // Ensure all cycles have a valid endDate
    const validCycles = accrualCycles.filter((cycle) => cycle?.endDate && !isNaN(new Date(cycle.endDate).getTime()));

    if (validCycles.length === 0) {
      return null;
    }

    return validCycles.slice().sort((a, b) => new Date(b.endDate).getTime() - new Date(a.endDate).getTime())[0];
  } catch (error) {
    console.error("Error in getLatestCycle:", error);
    return null;
  }
}
